"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var ComponentWrapper = function ComponentWrapper(_ref) {
  var children = _ref.children,
    noPadding = _ref.noPadding,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('container', className || 'max-width-lg'),
    style: {
      padding: !noPadding ? 'var(--component-padding) 0' : 0
    }
  }, children);
};
ComponentWrapper.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].func]).isRequired,
  noPadding: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var _default = exports["default"] = ComponentWrapper;